if (!customElements.get("collection-explore-gallery")) {
  customElements.define(
    "collection-explore-gallery",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!window.app?.Splide) return;

        if (this.querySelector(".collection-explore-slider")) {
          this.initCollectionExploreSlider();
        } else {
          this.initCollectionExploreGallery();
        }
      }

      initCollectionExploreGallery() {
        const options = {
          type: "slide",
          perPage: 3.2,
          perMove: 1,
          gap: 10,
          pagination: false,
          arrows: true,
          keyboard: "focused",
          trimSpace: true,
          speed: 800,
          padding: {
            left: "60px",
            right: "60px",
          },
          breakpoints: {
            1024: {
              perPage: 2.3,
              gap: 20,
              padding: {
                left: "20px",
                right: "20px",
              },
            },
            640: {
              perPage: 1.2,
              gap: 20,
              padding: {
                left: "20px",
                right: "20px",
              },
            },
          },
        };

        this.slider = new window.app.Splide(
          this.querySelector(".splide"),
          options
        ).mount();
      }
      initCollectionExploreSlider() {
        this.exploreSlider = new window.app.Splide(
          this.querySelector(".collection-explore-slider"),
          {
            type: "slide",
            gap: 10,
            pagination: false,
            arrows: true,
            autoWidth: true,
            focus: 0,
            omitEnd: true,
          }
        ).mount();
      }
    }
  );
}
